import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// M3 — company-onboarding gate for Sender business routes. A SENDER without an active company
// membership is redirected to /onboarding. Staff / Super Admin (and members) pass through. This
// wraps children INSIDE RequireRole, so role checks have already run.
// A11 — existing-shipment routes pass `allowInactive`: an INACTIVE company keeps its existing shipments.
export const COMPANY_INACTIVE_MESSAGE = "New bookings and commercial actions are paused for your company. Your existing shipments continue to be handled by Air12. Please contact Air12 to reactivate your company.";
export const isCompanyInactive = (profile) => profile?.role === "SENDER" && profile?.company_status === "INACTIVE";

export default function RequireSenderCompany({ children, allowInactive = false }) {
  const { profile, loading } = useAuth();
  if (loading) return <div className="p-10 mono text-sm">Loading…</div>;
  if (!profile) return <div className="p-10 mono text-sm">Provisioning profile…</div>;
  if (profile.role === "SENDER" && profile.onboarding_required) {
    return <Navigate to="/onboarding" replace />;
  }
  if (isCompanyInactive(profile) && !allowInactive) {
    return (
      <div className="max-w-lg mx-auto mt-16 p-8 grid-card grid-card-strong text-center" data-testid="company-inactive-block">
        <div className="text-lg font-semibold mb-2">Your company is currently inactive</div>
        <p className="text-sm text-[hsl(var(--muted))]">{COMPANY_INACTIVE_MESSAGE}</p>
      </div>
    );
  }
  return children;
}
